import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataUrbanity, dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Slide, toast } from "react-toastify";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import "../../style/setup.css";
import { ImportModalSetup } from "../../Components/Fragments/Modals/ModalSetupStoreImport";
import { exportproductmastersetup } from "../../services/productMasterService";

import ModalCreateProvince from "./Modals/Create/ModalProvince";
import ModalCreateRegency from "./Modals/Create/ModalRegency";
import ModalCreateDistrict from "./Modals/Create/ModalDistrict";
import { ModalConfirmation } from "../../Components/Fragments/Modals/ModalGeneral";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});

function SetupBpsSubDistrict() {
  const accessToken = Cookies.get("access_token") || "";

  const [sortBy, setSortBy] = useState("kel_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [filterColumnValue, setFilterColumnValue] = useState("");

  const [dataProfile, setDataProfile] = useState([]);
  const [dataProvinces, setDataProvinces] = useState([]);
  const [dataRegencies, setDataRegencies] = useState([]);
  const [dataDistricts, setDataDistricts] = useState([]);
  const [dataAreaCodes, setDataAreaCodes] = useState([]);
  const [dataRegenciesTemp, setDataRegenciesTemp] = useState([]);
  const [dataDistrictsTemp, setDataDistrictsTemp] = useState([]);

  const [provinceNameTemp, setProvinceNameTemp] = useState("");
  const [regencyNameTemp, setRegencyNameTemp] = useState("");

  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedRegency, setSelectedRegency] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");

  const [filteredRows, setFilteredRows] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState(
    "setup-bps-sub-district"
  );

  const [modalCreateProvince, setModalCreateProvince] = useState(false);
  const [modalCreateRegency, setModalCreateRegency] = useState(false);
  const [modalCreateDistrict, setModalCreateDistrict] = useState(false);

  const [modalAddSetup, setModalAddSetup] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [editDataId, setEditDataId] = useState(null);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [openDialogImport, setOpenDialogImport] = useState(false);
  const [excelFile, setExcelFile] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  const [newData, setNewData] = useState({
    province_id: "",
    regency_id: "",
    district_id: "",
    code: "",
    name: "",
    urbanity: "",
    areacode: 0,
  });

  const [openDialogConfirmationExport, setOpenDialogConfirmationExport] = useState(false);
  const [viewDataExport, setViewDataExport] = useState({
    title: null,
    process_at: null,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
      fetchProvince();
      fetchAreaCode();
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchRegency();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedProvince]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchDistrict();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedRegency]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (newData.province_id || editedData.province_id) {
        fetchRegencyForAction();
      } else setDataRegenciesTemp([]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [newData.province_id, editedData.province_id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (newData.regency_id || editedData.regency_id) {
        fetchDistrictForAction();
      } else setDataDistrictsTemp([]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [newData.regency_id, editedData.regency_id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [
    accessToken,
    currentPage,
    itemsPerPage,
    selectedProvince,
    selectedRegency,
    selectedDistrict,
    sortBy,
    sortOrder,
  ]);

  async function fetchProvince() {
    const token = Cookies.get("access_token");

    setDataProvinces([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/province` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setDataProvinces(newArray);
        // setSelectedProvince(data[0].code);
      } else {
        setDataProvinces([]);
      }
    } catch (error) {
      setDataProvinces([]);
    }
    setIsLoading(false);
  }

  async function fetchRegency() {
    if (selectedProvince) {
      const token = Cookies.get("access_token");

      setDataRegencies([]);
      setIsLoading(true);

      const queryParams = new URLSearchParams();

      queryParams.append("province_code", selectedProvince);

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/regency` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.name,
            value: item.code,
          }));
          setDataRegencies(newArray);
          // setSelectedRegency(data[0].code);
        } else {
          setDataRegencies([]);
        }
      } catch (error) {
        setDataRegencies([]);
      }
      setIsLoading(false);
    }
  }

  async function fetchDistrict() {
    if (selectedProvince && selectedRegency) {
      const token = Cookies.get("access_token");

      setDataDistricts([]);
      setIsLoading(true);

      const queryParams = new URLSearchParams();

      queryParams.append("regency_code", selectedRegency);

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/district` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.name,
            value: item.code,
          }));
          setDataDistricts(newArray);
          // setSelectedDistrict(data[0].code);
        } else {
          setDataDistricts([]);
        }
      } catch (error) {
        setDataDistricts([]);
      }
      setIsLoading(false);
    }
  }

  async function fetchRegencyForAction() {
    const token = Cookies.get("access_token");

    setDataRegenciesTemp([]);

    const queryParams = new URLSearchParams();

    queryParams.append(
      "province_code",
      newData.province_id || editedData.province_id
    );

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/regency` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setDataRegenciesTemp(newArray);
      } else {
        setDataRegenciesTemp([]);
      }
    } catch (error) {
      setDataRegenciesTemp([]);
    }
  }

  async function fetchDistrictForAction() {
    const token = Cookies.get("access_token");

    setDataDistrictsTemp([]);

    const queryParams = new URLSearchParams();

    queryParams.append(
      "regency_code",
      newData.regency_id || editedData.regency_id
    );

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/district` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setDataDistrictsTemp(newArray);
      } else {
        setDataDistrictsTemp([]);
      }
    } catch (error) {
      setDataDistrictsTemp([]);
    }
  }

  async function fetchAreaCode() {
    const token = Cookies.get("access_token");

    setDataAreaCodes([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/areacode` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.areadesc,
          value: item.areacode,
        }));
        setDataAreaCodes(newArray);
      } else {
        setDataAreaCodes([]);
      }
    } catch (error) {
      setDataAreaCodes([]);
    }
  }

  async function fetchMainData(customParams = filterColumnValue) {
    const token = Cookies.get("access_token");

    setFilteredRows([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    if (selectedProvince) {
      queryParams.append("province_code", selectedProvince);
    }

    if (selectedRegency) {
      queryParams.append("regency_code", selectedRegency);
    }

    if (selectedDistrict) {
      queryParams.append("district_code", selectedDistrict);
    }

    queryParams.append("need_detail_info", true);
    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("sort_by", sortBy);
    queryParams.append("sort_order", sortOrder);

    if (customParams) {
      queryParams.append("column_value", customParams);
      queryParams.append("column_operator", "LIKE");
    }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/sub-district` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setFilteredRows(data.data);
      } else {
        setFilteredRows([]);
      }
    } catch (error) {
      setFilteredRows([]);
    }

    setIsLoading(false);
  }

  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  const handleProvinceChange = (newValue) => {
    if (newValue) {
      setSelectedProvince(newValue.value);
      setSelectedRegency("");
      setSelectedDistrict("");
      setCurrentPage(1);
    } else {
      setSelectedProvince("");
      setSelectedRegency("");
      setSelectedDistrict("");
      setCurrentPage(1);
    }
  };

  const handleRegencyChange = (newValue) => {
    if (newValue) {
      setSelectedRegency(newValue.value);
      setSelectedDistrict("");
      setCurrentPage(1);
    } else {
      setSelectedRegency("");
      setSelectedDistrict("");
      setCurrentPage(1);
    }
  };

  const handleDistrictChange = (newValue) => {
    if (newValue) {
      setSelectedDistrict(newValue.value);
      setCurrentPage(1);
    } else {
      setSelectedDistrict("");
      setCurrentPage(1);
    }
  };

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleCreateData = async () => {
    const token = Cookies.get("access_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/sub-district`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (response.status === 201) {
        toast.success("Data berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setModalAddSetup(false);
        setNewData({
          province_id: "",
          code: "",
          name: "",
          area: "",
        });
        setFilterColumnValue("");
        setCurrentPage(1);
        await fetchMainData("");
      } else if (response.status == 422) {
        toast.error("Data gagal diproses!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating Data:", error);
    }
  };

  const handleAddNewSetup = () => {
    setModalAddSetup(true);
  };

  const handleEditClick = async (row) => {
    setEditedData({
      province_id: row.province_code,
      regency_id: row.kab_code,
      district_id: row.kec_code,
      name: row.kel_name,
      urbanity: row.urbanity,
      areacode: row.areacode,
    });
    setProvinceNameTemp(row.province_name);
    setRegencyNameTemp(row.kab_name);
    setEditDataId(row.kel_code);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditedData({});
    setProvinceNameTemp("");
    setRegencyNameTemp("");
  };

  const handleUpdateData = async () => {
    setIsLoading(true);
    if (editDataId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/sub-district/${editDataId}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setEditModalOpen(false);
          setFilterColumnValue("");
          setCurrentPage(1);
          await fetchMainData("");
        } else if (response.status == 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const handleResetFilter = () => {
    setFilterColumnValue("");
    setSelectedProvince("");
    setSelectedRegency("");
    setSelectedDistrict("");
    setCurrentPage(1);
    fetchMainData("");
    fetchProvince();
    setDataRegencies([]);
    setDataDistricts([]);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setCurrentPage(1);
    fetchMainData();
  };

  // upload data
  const refreshData = () => {
    fetchMainData();
  };

  const handleImportData = () => {
    setOpenDialogImport(true);
  };

  const handleCloseDialog = () => {
    setOpenDialogImport(false);
    setExcelFile("");
    setFileUrl("");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await importDataTemplate();
    setIsLoading(false);
  };

  async function importDataTemplate() {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/sub-district/import/template`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      if (response.status === 201) {
        toast.success("Upload Sub District berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setOpenDialogImport(false);
        //refresh
        setCurrentPage(1);
        refreshData();
      } else if (response.status === 200) {
        // throw data as blob then download it when validation on excel got fail
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Sub District Error.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        toast.error("Ada masalah di excel. Periksa kembali isi excel!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else if (response.status === 400) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error("Gagal mengimport Sub District Setup!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error(
          "Failed to import Sub District template:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error importing Sub District template:", error);
    }
  }

  async function exportDataTemplate() {
    setIsLoading(true);
    const blob = await exportproductmastersetup(
      accessToken,
      "template",
      "api/v1/sub-district/export/template",
      {}
    );
    if (blob) {
      // throw data as blob then download it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Template Sub District.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      toast.error("Gagal mendownload template Sub District!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  }

  const handleProcessExport = async () => {
    setIsLoading(true);
    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module`;

    const body = {
      title: "Stat Module - Setup BPS Kelurahan",
      setup: "sub_district",
      province_code: selectedProvince || null,
      regency_code: selectedRegency || null,
      district_code: selectedDistrict || null,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        toast.success("Data akan diproses kedalam antrian.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Gagal memulai proses export!", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error("Terjadi kesalahan jaringan saat memulai proses export.");
    }
    setIsLoading(false);
  };

  const handleConfirmationExport = async () => {
    setIsLoading(true);

    const setup = "sub_district";

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/${setup}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 200) {
      const { data } = await response.json();
      setOpenDialogConfirmationExport(true);
      setViewDataExport({
        title: data.data.title ?? "stat module - export result",
        process_at: data.process_at,
      });
    } else if (response.status === 400 || response.status === 404) {
      const { detail } = await response.json();
      toast.error(detail || "Data sedang diproses", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    } else {
      const { detail } = await response.json();
      toast.error(detail || "Tidak ditemukan excel, klik Process terlebih dahulu", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      });
    }
    setIsLoading(false);
  };

  const handleCloseConfirmationExport = () => {
    setOpenDialogConfirmationExport(false);
    // clear data
    setViewDataExport({
      title: "",
      process_at: "",
    });
  };

  const handleExportResult = async () => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();

      const setup = "sub_district";

      // Construct the full URL with query parameters
      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/process_queue/stat_module/export/${setup}` +
        (queryString ? `?${queryString}` : "");

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const filename = `${viewDataExport.title || "stat module - export result"}.xlsx`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        handleCloseConfirmationExport();
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        toast.error(data.detail, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        toast.error('Gagal mengunduh', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        console.error('Failed to export process queue:', response.statusText);
      }
    } catch (error) {
      console.error('Error export process queue:', error);
    }
    setIsLoading(false);
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell
      style={tableCellStyle}
      sx={{ border: 1, borderColor: "grey.300" }}
    >
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Stat Module"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Stat Module"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={0.5}>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataStatModules}
                getOptionLabel={(option) => option.label}
                value={
                  dataStatModules.find(
                    (option) => option.value === searchBarValue
                  ) || null
                }
                onChange={(e, newValue) => handleTableSelection(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cari Kategori"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disableClearable
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataProvinces}
                getOptionLabel={(option) => option.label}
                value={
                  dataProvinces.find(
                    (option) => option.value === selectedProvince
                  ) || null
                }
                onChange={(e, newValue) => handleProvinceChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Pilih Provinsi"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataRegencies}
                getOptionLabel={(option) => option.label}
                value={
                  dataRegencies.find(
                    (option) => option.value === selectedRegency
                  ) || null
                }
                onChange={(e, newValue) => handleRegencyChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Pilih Kab/Kota"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataDistricts}
                getOptionLabel={(option) => option.label}
                value={
                  dataDistricts.find(
                    (option) => option.value === selectedDistrict
                  ) || null
                }
                onChange={(e, newValue) => handleDistrictChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Pilih Kecamatan"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <form
                onSubmit={handleSearch}
                style={{ display: "flex", alignItems: "center" }}
              >
                <TextField
                  sx={{
                    mr: 0.5,
                    height: 40,
                  }}
                  name="column_value"
                  label="Cari"
                  size="small"
                  value={filterColumnValue}
                  onChange={(e) => {
                    setFilterColumnValue(e.target.value);
                  }}
                />
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: 120, height: 40 }}
                  type="submit"
                  disabled={isLoading || !filterColumnValue}
                >
                  {isLoading ? "Loading..." : "Cari"}
                </BootstrapButton>
              </form>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                sx={{ width: 150, height: 40 }}
                onClick={handleResetFilter}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Reset Filter"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleAddNewSetup}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Add"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleImportData}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Upload"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleProcessExport}
                disabled={isLoading}
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Process"}
              </BootstrapButton>
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleConfirmationExport}
                disabled={isLoading}
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              >
                {isLoading ? "Loading..." : "Download"}
              </BootstrapButton>
            </Grid>
          </Grid>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 650 }}>
            <Table
              aria-label="simple table"
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  {sortTableCell("Province Code", "province_code")}
                  {sortTableCell("Province Name", "province_name")}
                  {sortTableCell("Kab/Kota Code", "kab_code")}
                  {sortTableCell("Kab/Kota Name", "kab_name")}
                  {sortTableCell("Kecamatan Code", "kec_code")}
                  {sortTableCell("Kecamatan Name", "kec_name")}
                  {sortTableCell("Kelurahan Code", "kel_code")}
                  {sortTableCell("Kelurahan Name", "kel_name")}
                  <TableCell
                    style={tableCellStyle}
                    sx={{ border: 1, borderColor: "grey.300" }}
                  >
                    Urbanity
                  </TableCell>
                  <TableCell
                    style={tableCellStyle}
                    sx={{ border: 1, borderColor: "grey.300" }}
                  >
                    Area Code
                  </TableCell>
                  <TableCell
                    style={tableCellStyle}
                    sx={{ border: 1, borderColor: "grey.300" }}
                  >
                    Area Code Description
                  </TableCell>
                  <TableCell
                    style={tableCellStyle}
                    sx={{ border: 1, borderColor: "grey.300" }}
                  >
                    Aksi
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <TableRow key={`${row.kel_code}-${row.kel_name}`}>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.province_code}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.province_name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kab_code}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kab_name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kec_code}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kec_name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kel_code}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.kel_name}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.urbanity}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.areacode}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        {row.area_description}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ border: 1, borderColor: "grey.300" }}
                      >
                        <Tooltip
                          title="Edit Data"
                          onClick={() => handleEditClick(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={10}
                      align="center"
                      sx={{ border: 1, borderColor: "grey.300" }}
                    >
                      {isLoading ? "Loading..." : "No Data Available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* pagination */}
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={itemsPerPageList}
              component="div"
              count={totalItems}
              rowsPerPage={itemsPerPage}
              page={currentPage - 1}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeItemPerPageSelect}
            />
          )}
        </Paper>

        <Modal
          open={modalAddSetup}
          onClose={() => {
            setModalAddSetup(false);
            setProvinceNameTemp("");
            setRegencyNameTemp("");
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <Tooltip title="Close Modal">
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => {
                  setModalAddSetup(false);
                  setNewData({
                    province_id: "",
                    regency_id: "",
                    code: "",
                    name: "",
                  });
                  setProvinceNameTemp("");
                  setRegencyNameTemp("");
                }}
                sx={{ position: "absolute", top: 20, right: 30 }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <div className="create-data">
              <h2 style={{ marginBottom: "15px" }}>Create Kelurahan</h2>
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <div style={{ width: "80%" }}>
                  <Autocomplete
                    options={dataProvinces}
                    getOptionLabel={(option) => option.label}
                    value={
                      dataProvinces.find(
                        (option) => option.value === newData.province_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleSetupInputChange({
                        target: {
                          name: "province_id",
                          value: newValue ? newValue.value : "",
                        },
                      });
                      setProvinceNameTemp(newValue ? newValue.label : "");
                      setNewData((prevData) => ({
                        ...prevData,
                        regency_id: "",
                      }));
                      setNewData((prevData) => ({
                        ...prevData,
                        district_id: "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="PROVINSI" />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disableClearable
                  />
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                  }}
                >
                  <button
                    style={{
                      width: "50%",
                      backgroundColor: "#FFFFFF00",
                      border: "none",
                      height: "100%",
                    }}
                    onClick={() => fetchProvince()}
                  >
                    <RefreshIcon
                      style={{
                        fontSize: 30,
                        color: "#757575",
                        cursor: "pointer",
                      }}
                    />
                  </button>
                  <button
                    style={{
                      width: "50%",
                      backgroundColor: "#FFFFFF00",
                      border: "none",
                      height: "100%",
                    }}
                    onClick={() => setModalCreateProvince(true)}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <HourglassEmptyIcon
                        style={{ fontSize: 30, color: "#BBBBBB" }}
                      />
                    ) : (
                      <AddIcon
                        style={{
                          fontSize: 35,
                          color: "#757575",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </button>
                </div>
              </div>
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <div style={{ width: "80%" }}>
                  <Autocomplete
                    options={dataRegenciesTemp}
                    getOptionLabel={(option) => option.label}
                    value={
                      dataRegenciesTemp.find(
                        (option) => option.value === newData.regency_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleSetupInputChange({
                        target: {
                          name: "regency_id",
                          value: newValue ? newValue.value : "",
                        },
                      });
                      setRegencyNameTemp(newValue ? newValue.label : "");
                      setNewData((prevData) => ({
                        ...prevData,
                        district_id: "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="KAB/KOTA" />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disableClearable
                  />
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                  }}
                >
                  <button
                    style={{
                      width: "50%",
                      backgroundColor: "#FFFFFF00",
                      border: "none",
                      height: "100%",
                    }}
                    onClick={() => fetchRegencyForAction()}
                  >
                    <RefreshIcon
                      style={{
                        fontSize: 30,
                        color: "#757575",
                        cursor: "pointer",
                      }}
                    />
                  </button>
                  {newData.province_id && (
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      onClick={() => setModalCreateRegency(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <HourglassEmptyIcon
                          style={{ fontSize: 30, color: "#BBBBBB" }}
                        />
                      ) : (
                        <AddIcon
                          style={{
                            fontSize: 35,
                            color: "#757575",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </button>
                  )}
                </div>
              </div>
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <div style={{ width: "80%" }}>
                  <Autocomplete
                    options={dataDistrictsTemp}
                    getOptionLabel={(option) => option.label}
                    value={
                      dataDistrictsTemp.find(
                        (option) => option.value === newData.district_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleSetupInputChange({
                        target: {
                          name: "district_id",
                          value: newValue ? newValue.value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="KECAMATAN" />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    disableClearable
                  />
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                  }}
                >
                  <button
                    style={{
                      width: "50%",
                      backgroundColor: "#FFFFFF00",
                      border: "none",
                      height: "100%",
                    }}
                    onClick={() => fetchDistrictForAction()}
                  >
                    <RefreshIcon
                      style={{
                        fontSize: 30,
                        color: "#757575",
                        cursor: "pointer",
                      }}
                    />
                  </button>
                  {newData.regency_id && (
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      onClick={() => setModalCreateDistrict(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <HourglassEmptyIcon
                          style={{ fontSize: 30, color: "#BBBBBB" }}
                        />
                      ) : (
                        <AddIcon
                          style={{
                            fontSize: 35,
                            color: "#757575",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </button>
                  )}
                </div>
              </div>
              <div>
                <TextField
                  label="KODE"
                  name="code"
                  value={newData.code}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </div>
              <div>
                <TextField
                  label="NAME"
                  name="name"
                  value={newData.name}
                  onChange={handleSetupInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </div>
              <div>
                <Autocomplete
                  options={dataUrbanity}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataUrbanity.find(
                      (option) => option.value === newData.urbanity
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "urbanity",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="URBANITY" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <Autocomplete
                  options={dataAreaCodes}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataAreaCodes.find(
                      (option) => option.value === newData.areacode
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleSetupInputChange({
                      target: {
                        name: "areacode",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="AREA CODE" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>
              <div>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
                  onClick={handleCreateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Submit"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="edit-data">
              <h2>Edit Kelurahan</h2>
              <div>
                <div
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "5px",
                  }}
                >
                  <div style={{ width: "80%" }}>
                    <Autocomplete
                      options={dataProvinces}
                      getOptionLabel={(option) => option.label}
                      value={
                        dataProvinces.find(
                          (option) => option.value === editedData.province_id
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setEditedData({
                          ...editedData,
                          province_id: newValue ? newValue.value : "",
                        });
                        setProvinceNameTemp(newValue ? newValue.label : "");
                        setEditedData((prevData) => ({
                          ...prevData,
                          regency_id: "",
                        }));
                        setEditedData((prevData) => ({
                          ...prevData,
                          district_id: "",
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="PROVINSI" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      disableClearable
                    />
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                    }}
                  >
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      onClick={() => fetchProvince()}
                    >
                      <RefreshIcon
                        style={{
                          fontSize: 30,
                          color: "#757575",
                          cursor: "pointer",
                        }}
                      />
                    </button>
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      // onClick={() => setModalEditProvince(true)}
                      onClick={() => setModalCreateProvince(true)}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <HourglassEmptyIcon
                          style={{ fontSize: 30, color: "#BBBBBB" }}
                        />
                      ) : (
                        <AddIcon
                          style={{
                            fontSize: 35,
                            color: "#757575",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "5px",
                  }}
                >
                  <div style={{ width: "80%" }}>
                    <Autocomplete
                      options={dataRegenciesTemp}
                      getOptionLabel={(option) => option.label}
                      value={
                        dataRegenciesTemp.find(
                          (option) => option.value === editedData.regency_id
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setEditedData({
                          ...editedData,
                          regency_id: newValue ? newValue.value : "",
                        });
                        setRegencyNameTemp(newValue ? newValue.label : "");
                        setEditedData((prevData) => ({
                          ...prevData,
                          district_id: "",
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="KAB/KOTA" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      disableClearable
                    />
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                    }}
                  >
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      onClick={() => fetchRegencyForAction()}
                    >
                      <RefreshIcon
                        style={{
                          fontSize: 30,
                          color: "#757575",
                          cursor: "pointer",
                        }}
                      />
                    </button>
                    {editedData.province_id && (
                      <button
                        style={{
                          width: "50%",
                          backgroundColor: "#FFFFFF00",
                          border: "none",
                          height: "100%",
                        }}
                        // onClick={() => setModalEditRegency(true)}
                        onClick={() => setModalCreateRegency(true)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <HourglassEmptyIcon
                            style={{ fontSize: 30, color: "#BBBBBB" }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              fontSize: 35,
                              color: "#757575",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </button>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "5px",
                  }}
                >
                  <div style={{ width: "80%" }}>
                    <Autocomplete
                      options={dataDistrictsTemp}
                      getOptionLabel={(option) => option.label}
                      value={
                        dataDistrictsTemp.find(
                          (option) => option.value === editedData.district_id
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setEditedData({
                          ...editedData,
                          district_id: newValue ? newValue.value : "",
                        });
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="KECAMATAN" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      disableClearable
                    />
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                    }}
                  >
                    <button
                      style={{
                        width: "50%",
                        backgroundColor: "#FFFFFF00",
                        border: "none",
                        height: "100%",
                      }}
                      onClick={() => fetchDistrictForAction()}
                    >
                      <RefreshIcon
                        style={{
                          fontSize: 30,
                          color: "#757575",
                          cursor: "pointer",
                        }}
                      />
                    </button>
                    {editedData.regency_id && (
                      <button
                        style={{
                          width: "50%",
                          backgroundColor: "#FFFFFF00",
                          border: "none",
                          height: "100%",
                        }}
                        onClick={() => setModalCreateDistrict(true)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <HourglassEmptyIcon
                            style={{ fontSize: 30, color: "#BBBBBB" }}
                          />
                        ) : (
                          <AddIcon
                            style={{
                              fontSize: 35,
                              color: "#757575",
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </button>
                    )}
                  </div>
                </div>
                <TextField
                  name="name"
                  label="Name"
                  sx={{ width: "100%", mb: 2 }}
                  value={editedData.name ?? ""}
                  onChange={(e) =>
                    setEditedData({
                      ...editedData,
                      name: e.target.value,
                    })
                  }
                ></TextField>
                <Autocomplete
                  options={dataUrbanity}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataUrbanity.find(
                      (option) => option.value === editedData.urbanity
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      urbanity: newValue ? newValue.value : "",
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="URBANITY" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
                <Autocomplete
                  options={dataAreaCodes}
                  getOptionLabel={(option) => option.label}
                  value={
                    dataAreaCodes.find(
                      (option) => option.value === editedData.areacode
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setEditedData({
                      ...editedData,
                      areacode: newValue ? newValue.value : 0,
                    });
                  }}
                  sx={{ mb: 2 }}
                  renderInput={(params) => (
                    <TextField {...params} label="AREA CODE" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable
                />
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseEditModal}
                >
                  Cancel
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleUpdateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "UPDATE"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>

        <ModalConfirmation
          open={openDialogConfirmationExport}
          onClose={handleCloseConfirmationExport}
          title={'Konfirmasi Download'}
          confirmationText={'Yes'}
          description={`Ditemukan ${viewDataExport.title} terakhir diproses pada ${viewDataExport.process_at}. Apakah anda yakin ingin download rawdata ini?`}
          isLoading={isLoading}
          handleClick={handleExportResult}
        />
        
        <ModalCreateProvince
          refreshData={fetchProvince}
          modalCreateProvince={modalCreateProvince}
          setModalCreateProvince={setModalCreateProvince}
        />

        <ModalCreateRegency
          refreshData={() => {
            // fetchRegency();
            fetchRegencyForAction();
          }}
          modalCreateRegency={modalCreateRegency}
          setModalCreateRegency={setModalCreateRegency}
          provinceSelectedId={newData?.province_id || editedData?.province_id}
          provinceName={provinceNameTemp}
          setProvinceName={setProvinceNameTemp}
        />

        <ModalCreateDistrict
          refreshData={() => {
            // fetchDistrict();
            fetchDistrictForAction();
          }}
          modalCreateDistrict={modalCreateDistrict}
          setModalCreateDistrict={setModalCreateDistrict}
          provinceSelectedId={newData?.province_id || editedData?.province_id}
          regencySelectedId={newData?.regency_id || editedData?.regency_id}
          provinceName={provinceNameTemp}
          setProvinceName={setProvinceNameTemp}
          regencyName={regencyNameTemp}
          setRegencyName={setRegencyNameTemp}
        />
        
        <ImportModalSetup
          isLoading={isLoading}
          open={openDialogImport}
          onClose={handleCloseDialog}
          title={"Import Kelurahan"}
          buttonTitle={"Upload"}
          fileUrl={fileUrl}
          handleSubmit={handleUpload}
          handleChange={{
            excel: setExcelFile,
            fileUrl: setFileUrl,
          }}
          handleExport={{
            template: exportDataTemplate,
          }}
        />
      </div>
    </div>
  );
}

export default SetupBpsSubDistrict;
